"use client";

import Link from "./CustomLink";
import { useState } from "react";
import { cn } from "~/utils/cn";

export default function HoverMenu({
  title,
  url,
  subLinks,
}: {
  title: string;
  url: string;
  subLinks: { title: string; url: string }[];
}) {
  const [open, setOpen] = useState(false);

  return (
    <li className="h-full">
      <div onMouseLeave={() => setOpen(false)} className="relative h-full">
        <Link
          key={title}
          to={url}
          aria-label={title}
          onMouseOver={() => setOpen(true)}
          className="flex h-full items-center px-2 text-[#E8ECF4]"
        >
          {title}
        </Link>
        <div
          className={cn("absolute left-0 shadow-lg", open ? "block" : "hidden")}
        >
          <div className="mt-1 w-40 bg-white">
            {subLinks.map((subLink) => (
              <Link
                key={subLink.title}
                to={subLink.url}
                onClick={() => setOpen(false)}
                aria-label={subLink.title}
                className="flex h-11 w-full items-center px-2 py-1.5 hover:border-l-4 hover:border-blue hover:pl-1 hover:text-blue"
              >
                {subLink.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </li>
  );
}
